// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>
    dispatch => {

        dispatch({
            data: claim,
            isCopied: true,
            type: actions.COPY_CLAIM_BATTERY
        });

        dispatch(routerActions.replace('/claims/battery/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/copy-claim.js